import { useEffect } from 'react';
import { autoDetectAndStoreSource, getConversionSource } from '@/lib/context';

/**
 * SourceTracker Component
 * 
 * Automatically detects and stores the traffic source when the app loads.
 * This enables conversion attribution tracking for users arriving from:
 * - Social platforms (Facebook, LinkedIn, TikTok, Twitter, WhatsApp)
 * - Search engines (Google, Bing, Yahoo)
 * - Email campaigns
 * - Direct traffic
 * 
 * Usage: Include once in App.js
 * <SourceTracker />
 */
export const SourceTracker = ({ onSourceDetected }) => {
  useEffect(() => {
    // Auto-detect source on mount
    const detectedSource = autoDetectAndStoreSource();
    
    // Call callback if provided
    if (detectedSource && onSourceDetected) {
      onSourceDetected(detectedSource);
    }
    
    // Also track page views from external sources
    const source = getConversionSource();
    if (source && source.platform && source.platform !== 'internal') {
      // Could send analytics event here if needed
      // trackPageView(source);
    }
  }, [onSourceDetected]);
  
  // This component doesn't render anything
  return null;
};

export default SourceTracker;
